import { install as girassol } from '@solfacil/girassol';

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(girassol as any);
});
